interface DispatchEventParameters {
    eventType: any;
    element?: HTMLElement | null;
    bubbles?: boolean;
    cancelable?: boolean;
}

export const dispatchEvent = ({ element, eventType, bubbles = true, cancelable = true }: DispatchEventParameters) => {
    let event: Event;

    if (typeof Event === 'function') {
        event = new Event(eventType, { bubbles, cancelable });
    } else {
        // IE11 workaround
        event = document.createEvent('Event');
        event.initEvent(eventType, bubbles, cancelable);
    }

    const target = element || document;

    target.dispatchEvent(event);
};